<template>
  <div class="repo-notice-list">
    <h2 class="repo-notice-list__title">保理主合同列表</h2>
    <div class="repo-notice-list__content">
      <el-form ref="form" class="repo-notice-list__search" :inline="true" :model="search" label-width="90px">
        <el-form-item label="合同编号">
          <el-input v-model="search.contractNo"></el-input>
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input v-model="search.contractName"></el-input>
        </el-form-item>
        <el-form-item label="合同状态">
          <el-select v-model="search.contractState" placeholder="请选择">
            <el-option v-for="item in contractStateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="search-btn" @click="searchList">查询</el-button>
        </el-form-item>
      </el-form>

      <!--列表数据-->
      <el-table :data="projectContractList" style="width: 100%;overflow: hidde" align="center" class="repo-notice-list__table">
        <el-table-column prop="contractNo" show-overflow-tooltip label="合同编号"  align="center"></el-table-column>
        <el-table-column prop="contractName" show-overflow-tooltip label="合同名称"  align="center"></el-table-column>
        <el-table-column prop="contractState" show-overflow-tooltip label="合同状态" width="150"  align="center" :formatter="formatState">
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="showContract(scope.row.contractId,scope.row.contractState,scope.row.contractFinalFilePath)" class="btn operation">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="contractDiv">
        <el-dialog top="5%" width="80%" title="电子合同" :visible.sync="showAgreementDialog">
          <div class="contract__dialog-body agreement_contract">
            <iframe style="max-width:100%;width:98%;height:90%" :src="'./static/pdf/web/viewer.html?file=' + readContractPdf"></iframe>
          </div>
          <div slot="footer" class="dialog__footer">
            <el-button v-if="signBtn.isShow" class="dialog__footer__confirm-btn sign_btn" :disabled="signBtn.state" @click="signConstract" style="margin-right:30px;">
              {{signBtn.text}}
            </el-button>
            <!-- <a download="downloadImg" :href="downloadFiledPdf" class="down_agreen">下载</a> -->
          </div>
        </el-dialog>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import api from '../../api/projectContract.js';
import pdf from 'vue-pdf';
export default {
  components: { pdf },
  props: ['mainCount'],
  name: 'ProjectContractList',
  data () {
    return {
      search: {
        contractName: '',
        contractNo: '',
        contractType: '',
        contractState: '',
        frontApplyId: this.$route.query.frontApplyId
      },
      contractId: '',
      projectContractList: [],
      numPages: undefined,
      contractStateList: [
        { label: '平台已签章', value: '1' },
        { label: '平台待签章', value: '11' },
        { label: '待签章', value: '6' },
        { label: '法人已签字', value: '22' },
        { label: '已签章', value: '2' },
        { label: '资金方已签章', value: '4' },
        { label: '买方已签章', value: '3' },
      ],
      signBtn: {
        state: false,
        text: '签署公章',
        isShow: true
      },
      showAgreementDialog: false,
      downloadFiledPdf: '',
      readContractPdf: ''
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    })
  },
  methods: {
    ...mapMutations({
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE
    }),
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    getData (search) {
      const that = this;
      api.getMainContractList(search).then((resp) => {
        if (resp.data.code == 0) {
          that.projectContractList = resp.data.result;
        } else {
          that.projectContractList = [];
        }
      });
    },
    formatState (row, column) {
      const data = row[column.property];
      const map = {
        '1': '平台已签章',
        '11':'平台待签章',
        '2': '已签章',
        '22':'法人已签字',
        '6': '待签章',
        '3': '买方已签章',
        '4': '资金方已签章'
      };
      return map[data];
    },
    showContract (id, state,contractFinalFilePath) {
      if (state == '6') {
        this.signBtn.isShow = true;
      	this.signBtn.text = '法定代表人签章';
        this.signBtn.state = false;
      }else if (state == '22') {
        this.signBtn.isShow = true;
      	this.signBtn.text = '签署公章';
        this.signBtn.state = false;
      } else {
        this.signBtn.text = '已签章';
        this.signBtn.state = false;
        this.signBtn.isShow = false;
      }
      this.readContract(id,contractFinalFilePath);
      this.showAgreementDialog = true;
    },
    changePage (pageNum) {
      this.currentPage = pageNum;
      this.getData(this.search, this.currentPage);
    },
    searchList () {
      this.getData(this.search);
    },
    goToDetail (id) {
      this.$router.push(`/personalCenter/repoNotice/detail/${id}`);
    },
    readContract (id,contractFinalFilePath) {
      this.contractId = id;
      this.downloadFiledPdf = `${this.ajaxBaseUrl}/mobile/item/pdfSignatureController/blReadContractByIdForMain.ht?download=true&fileType=PDF&contractId=${id}&timestamp=`+new Date().getTime();
      /* if(contractFinalFilePath != ''){
        this.downloadFiledPdf = contractFinalFilePath;
      } */
      this.readContractPdf = encodeURIComponent(this.downloadFiledPdf);
    },
    signConstract () {
      this.$msgbox({
        title: "签署提示",
        message: "经过电子签章认证平台的认证后，通过该方式签署的各种合同文本均属于电子合同。您的签章行为即具有与实体印章及签名同等的法律效力。请妥善授权！",
        showClose: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
              const _this = this;
              this.signBtn.state = true;
              this.signBtn.text = '签章中…';
              api.signContractForMain({
                contractId: this.contractId
              }).then((res) => {
                if (res.code === 0) {
                  this.readContract(this.contractId);
                  if(res.result !== "签章成功"){
                    this.$msgbox({
                      title: "提示",
                      message: "请在打开的新页面完成签章操作",
                      showClose: false,
                      beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                          //this.$router.go(0);//刷新页面
                          this.getData(this.search);//刷新数据
                          this.showAgreementDialog  = false;
                          done();
                        } else {
                          done();
                        }
                      }
                    });            
                    window.open(res.result);
                    this.signBtn.text = '签署中…';
                    this.signBtn.state = true;
                  }else{
                    _this.setSuccessMessage({
                      show: true,
                      content: res.result
                    });
                    //location.reload();
                    this.signBtn.text = '已签章';
                    this.signBtn.state = true;
                    this.getData(this.search);
                  }
                } else {
                  _this.setFailMessage({
                    show: true,
                    content: res.result
                  });
                  this.signBtn.text = '签署公章';
                  this.signBtn.state = false;
                }
              }).catch((error) => {
        
              });
              done();
          } else {
            done();
          }
        }
      });        
    },
    downAgreement () {
      return '${this.ajaxBaseUrl}/mobile/item/pdfSignatureController/blReadContractById.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&contractId=${this.contractId}&id=${Math.random()}';
    }
  },
  mounted () {
    this.$emit('testClick2', this.mainCount);
    this.getData(this.search);
  }
};
</script>


<style>
.repo-notice-list__title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}
.repo-notice-list__content {
  box-sizing: border-box;
  background-color: #fff;
  width: 970px;
  margin-left: 20px;
  padding: 30px 22px 50px 18px;
}
.repo-notice-list__table .btn {
  width: 42px;
  height: 21px;
  padding: 1px;
}

.repo-notice-list__pagination {
  text-align: center;
  margin-top: 20px;
}
.repo-notice-list__search {
  width: 910px;
}
.repo-notice-list__search input {
  width: 150px;
}
.repo-notice-list__search .search-btn {
  margin-left: 30px;
  width: 80px;
}
.down_agreen,
.sign_btn:hover {
  display: inline-block;
  border: 0;
  min-width: 120px;
  height: 45px;
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  line-height: 45px;
  text-align: center;
  background: #ff8b38;
}
.el-table .el-tooltip.cell {
    white-space: nowrap;
    min-width: 50px;
    padding: 10px;
}
.contractDiv .el-dialog--small{
    width: 80%;
}
</style>



// WEBPACK FOOTER //
// MainProjectContractList.vue?7e8bc8dc